import React, { useState } from "react";
import "./LoadingIndicator.css";
import PropTypes, { InferProps } from "prop-types";

import "./AssessmentSummary.css";
import RadialBarChart from "./RadialBarChart";

export function AssessmentSummary(props: InferProps<typeof AssessmentSummary.propTypes>) {
  // State
  const [hoverZyklus, setHoverZyklus] = useState<number | null>();
  const [hoverLevel, setHoverLevel] = useState<string | null>();

  // Events
  const onHover = function (zyklus: number, level: string) {
    setHoverZyklus(zyklus);
    setHoverLevel(level);
  };

  const shouldRender = function (series: number[], zyklus: number | null): boolean {
    // No series?
    if (!series || series.length === 0) {
      return false;
    }

    // Only zero values?
    if (series.every((serie) => serie === 0)) {
      return false;
    }

    // No value for this Zyklus?
    if (zyklus && series.length < zyklus - 1) {
      return false;
    }

    // Zero value for this Zyklus?
    //if (zyklus && series[zyklus - 1] === 0) {
    //  return false;
    //}

    return true;
  };

  const styleCell = function (zyklus: number | null, level: string) {
    if (level === hoverLevel && (!zyklus || zyklus === hoverZyklus)) {
      return { backgroundColor: "#EEEEEE" };
    }

    return {};
  };

  const formatPercentage = function (value: number): string {
    if (!value || value === 0) {
      return "-";
    }

    return `${value}%`;
  };

  return (
    <div className="lp21-assessmentsummary">
      <RadialBarChart
        Height={props.height}
        Grundanspruch_Zyklus1={props.seriesCore[0]}
        Grundanspruch_Zyklus2={props.seriesCore[1]}
        Grundanspruch_Zyklus3={props.seriesCore[2]}
        VorangehendeKompetenzstufen_Zyklus1={props.showDetailedSummary && props.seriesPre && props.seriesPre[0]}
        VorangehendeKompetenzstufen_Zyklus2={props.showDetailedSummary && props.seriesPre && props.seriesPre[1]}
        VorangehendeKompetenzstufen_Zyklus3={props.showDetailedSummary && props.seriesPre && props.seriesPre[2]}
        WeiterfuehrendeKompetenzstufen_Zyklus1={props.showDetailedSummary && props.seriesPost && props.seriesPost[0]}
        WeiterfuehrendeKompetenzstufen_Zyklus2={props.showDetailedSummary && props.seriesPost && props.seriesPost[1]}
        WeiterfuehrendeKompetenzstufen_Zyklus3={props.showDetailedSummary && props.seriesPost && props.seriesPost[2]}
        onHover={onHover}
        showGrundanspruchOnly={!props.showDetailedSummary}
      />

      {props.renderLegend && (
        <>
          <div className="lp21-legend-static">
            {shouldRender(props.seriesCore, null) && (
              <div className="lp21-label lp21-grundanspruch" style={styleCell(null, "grundanspruch")}>
                Grundanspruch
              </div>
            )}
            {shouldRender(props.seriesCore, 1) && (
              <div className="lp21-percentage lp21-grundanspruch lp21-zyklus1" style={styleCell(1, "grundanspruch")}>
                {formatPercentage(props.seriesCore[0])}
              </div>
            )}
            {shouldRender(props.seriesCore, 2) && (
              <div className="lp21-percentage lp21-grundanspruch lp21-zyklus2" style={styleCell(2, "grundanspruch")}>
                {formatPercentage(props.seriesCore[1])}
              </div>
            )}
            {shouldRender(props.seriesCore, 3) && (
              <div className="lp21-percentage lp21-grundanspruch lp21-zyklus3" style={styleCell(3, "grundanspruch")}>
                {formatPercentage(props.seriesCore[2])}
              </div>
            )}

            {props.showDetailedSummary && (
              <>
                {props.seriesPre && shouldRender(props.seriesPre, null) && (
                  <div className="lp21-label lp21-vorangehend" style={styleCell(null, "vorangehend")}>
                    Vorangehende Kompetenzstufen
                  </div>
                )}
                {props.seriesPre && shouldRender(props.seriesPre, 1) && (
                  <div className="lp21-percentage lp21-vorangehend lp21-zyklus1" style={styleCell(1, "vorangehend")}>
                    {formatPercentage(props.seriesPre[0])}
                  </div>
                )}
                {props.seriesPre && shouldRender(props.seriesPre, 2) && (
                  <div className="lp21-percentage lp21-vorangehend lp21-zyklus2" style={styleCell(2, "vorangehend")}>
                    {formatPercentage(props.seriesPre[1])}
                  </div>
                )}
                {props.seriesPre && shouldRender(props.seriesPre, 3) && (
                  <div className="lp21-percentage lp21-vorangehend lp21-zyklus3" style={styleCell(3, "vorangehend")}>
                    {formatPercentage(props.seriesPre[2])}
                  </div>
                )}

                {props.seriesPost && shouldRender(props.seriesPost, null) && (
                  <div className="lp21-label lp21-weiterfuehrend" style={styleCell(null, "weiterfuehrend")}>
                    Weiterführende Kompetenzstufen
                  </div>
                )}
                {props.seriesPost && shouldRender(props.seriesPost, 1) && (
                  <div className="lp21-percentage lp21-weiterfuehrend lp21-zyklus1" style={styleCell(1, "weiterfuehrend")}>
                    {formatPercentage(props.seriesPost[0])}
                  </div>
                )}
                {props.seriesPost && shouldRender(props.seriesPost, 2) && (
                  <div className="lp21-percentage lp21-weiterfuehrend lp21-zyklus2" style={styleCell(2, "weiterfuehrend")}>
                    {formatPercentage(props.seriesPost[1])}
                  </div>
                )}
                {props.seriesPost && shouldRender(props.seriesPost, 3) && (
                  <div className="lp21-percentage lp21-weiterfuehrend lp21-zyklus3" style={styleCell(3, "weiterfuehrend")}>
                    {formatPercentage(props.seriesPost[2])}
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

AssessmentSummary.propTypes = {
  seriesCore: PropTypes.array.isRequired,
  seriesPre: PropTypes.array,
  seriesPost: PropTypes.array,
  labels: PropTypes.array.isRequired,
  height: PropTypes.number,
  renderAsImage: PropTypes.bool,
  renderLegend: PropTypes.bool,
  showDetailedSummary: PropTypes.bool.isRequired,
};

export default AssessmentSummary;
